var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',{attrs:{"with_go_back_bar":""}},[_c('kt-panel',[_c('kt-panel-body',[_c('kt-row',[_c('kt-col',{attrs:{"lg":"12","md":"12","sm":"12"}},[_c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false))],1),_c('kt-col',{attrs:{"lg":"6","md":"6","sm":"12"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }